import { theme } from '@zappyrent/hundop';
import styled from 'styled-components';
export const RadiobuttonContainer = styled.div`
  display: flex;
  vertical-align: middle;
  flex-direction: row;
  gap: 0.3rem;
  align-items: center;
`;

export const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

export const StyledRadiobutton = styled.div<{ checked?: boolean }>`
  display: flex;
  width: 16px;
  height: 16px;
  background: #fff;
  border-radius: 0.5rem;
  border-color: ${theme.colors.cross.grayson};
  border-width: 0.1rem;
  border-style: solid;
  transition: all 150ms;
  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')};
  }
`;
